import React, { useEffect, Fragment, useState } from 'react'
import {
    CCard,
    CImg,
    CImage,
    CCardHeader, CCardTitle,
    CCardBody,
    CCardFooter, CCol, CRow, CNavLink
} from 'compat/coreui';
import ReviewSection from './ReviewSection';
import BusinessMenu from './BusinessMenu';

var Carousel = require('react-responsive-carousel').Carousel;

export default function BusinessDashboard({ seller }) {
    const [compCard, setCompCard] = useState('dashboard');

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const getItemCount = id => {
        return seller.products.filter(p => p.category === id).length
    }
    return (
        <React.Fragment>
            <CCard className="business-dashboard-new">
                <CCardBody>
                    <CRow style={{ fontSize: '14px' }} className="dashboard_amitments_top">
                        <CCol sm={12} lg={6} className="geoloc-section profile_content">
                            <span className="map_wrap">
                                {/* <CImg src="/images/static-map.png" width="62%" alt="map" className="map_wrap_img" /> */}
                                </span>
                            <div className="profile_left_subnav">
                                <ul>
                                    <li><span style={{ marginRight: "6px" }}><i className="fa fa-map-marker"></i></span>{seller.city} {seller.state} {seller.pincode}</li>
                                    <li><span style={{ marginRight: "6px" }}><i className="fa fa-phone"></i></span>{seller.ownerPhone}</li>
                                    <li><span style={{ marginRight: "6px" }}><i className="fa fa-phone"></i></span>{seller.website}</li>
                                    <li><span style={{ marginRight: "6px" }}><i className="fa fa-phone"></i></span>{seller.businessType}</li>
                                    <li>
                                        <span style={{ color: 'green', marginRight: "6px" }}>
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                        </span>
                                    Open (Show More) Sun 9am - 10pm
                                </li>
                                </ul>
                            </div>
                        </CCol>
                        <CCol sm={12} lg={6} >
                            <div className="dashboard_amitments">
                                <h3 style={{ color: 'green' }}>Amenities</h3>
                                <div className="business-dash-amenities">
                                    <ul>
                                        <li><i className="fa fa-truck"></i> Delivery Only</li>
                                        <li><i className="fa fa-phone"></i> Recreational</li>
                                        <li><i className="fa fa-star"></i> Veteran Discounts</li>
                                    </ul>
                                    <h3 style={{ color: 'green' }}>First Time Patients</h3>
                                    <span className="ml-2">{seller.note}</span>
                                    <h3 style={{ color: 'green' }}>About</h3>
                                    <span className="ml-2">{seller.about}</span>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard className="business-dashboard-new">
                <CCardHeader className="d-flex deal-heading">
                    <CImage src="/images/calendar.png" width="60" height="60" alt="cal" />
                    <h3>Today's Deal</h3>
                </CCardHeader>
                <CCardBody className="deal-business-card">
                    <CRow>
                        {(seller && seller.deals) && Object.values(seller.deals).map((dealItem, i) => {
                            return (<CCol lg={4} key={i}>
                                <CCard className="m-3">
                                    <CCardHeader className="p-0 b-header">
                                        <CImage src="/images/product-1.jpg" width="100%" alt="product" />
                                    </CCardHeader>
                                    <CCardBody className="text-center">
                                        <div className="text-align">
                                            <CCardTitle>
                                                <p>{dealItem.title}</p>
                                            </CCardTitle>
                                        </div>
                                    </CCardBody>
                                    <CCardFooter className="deal-footer d-footer" >
                                        <span className="d-footer">Flower</span><span className="d-footer">Both</span><span className="d-footer"> 2096</span>
                                    </CCardFooter>
                                </CCard>
                            </CCol>)
                        }
                        )}
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard className="profile_content business-dashboard-new" style={{ zIndex: 0 }}>
                <div className="biz_module biz_menu c_12 doaj" data-position="rig">
                    <h3 className="heading" style={{ color: '#FF5F1F' }}>Menu &amp; Products</h3>
                    <fieldset className="menus">
                        <ul className="aj menu_pro">
                            {(seller && seller.menus) && Object.values(seller.menus).map((item, i) => (
                                <li className="menu_headline" key={i}>
                                    <Fragment>
                                        <img src="/images/indica.jpg" className="category_img" alt="Indica" />
                                        <span>
                                            <span className="title">{item.title} </span><br />
                                            <span className="count">{getItemCount(item._id)} Items $40 - $60 per</span>
                                        </span>
                                    </Fragment>
                                </li>

                            ))}
                        </ul>
                        <p className="updated">Menu last updated January 2, 2021</p>
                    </fieldset>
                    <span className="pre_order_stats">
                        <span className="oo_cta">
                            {/* <a href="/">
                        Pre-Order Now</a> */}
                            <CNavLink active={compCard === 'menu'} onClick={() => setCompCard('menu')}>Menu &amp; Products</CNavLink>

                        </span>
                    </span>
                </div>
            </CCard>
            <ReviewSection seller={seller} />
        </React.Fragment>
    )
}